export const resultsStats = [
  { value: 12, suffix: ' млн', label: 'подписчиков привлекли' },
  { value: 340, suffix: ' тыс', label: 'заявок и лидов собрали' },
  { value: 240, suffix: '+', label: 'сообществ продвинули' },
  { value: 35, suffix: '%', label: 'средний прирост охвата в месяц' },
];

export const platformResults = [
  { icon: 'fa-brands fa-vk', color: '#0077FF', name: 'ВКонтакте', value: '8,4 млн', label: 'подписчиков', growth: '+31%' },
  { icon: 'fa-brands fa-telegram', color: '#2AABEE', name: 'Telegram', value: '2,1 млн', label: 'подписчиков', growth: '+38%' },
  { icon: 'fa-brands fa-yandex', color: '#FC3F1D', name: 'Яндекс Директ', value: '1,6 млн', label: 'заявок', growth: '+24%' },
  { icon: 'fa-brands fa-odnoklassniki', color: '#EE8208', name: 'Одноклассники', value: '760 тыс', label: 'подписчиков', growth: '+19%' },
  { icon: 'fa-solid fa-spa', color: '#FF6B00', name: 'Дзен', value: '45 млн', label: 'просмотров', growth: '+26%' },
  { icon: 'fa-solid fa-store', color: '#97CF26', name: 'Avito', value: '920 тыс', label: 'заявок', growth: '+22%' },
  { icon: 'fa-solid fa-bullhorn', color: '#0077FF', name: 'VK Реклама', value: '5,2 млн', label: 'охват', growth: '+29%' },
  { icon: 'fa-solid fa-bullseye', color: '#00A76F', name: 'myTarget', value: '1,1 млн', label: 'охват', growth: '+21%' },
];

export const growthShowcase = [
  {
    company: 'Кофейня «Roast»',
    niche: 'Кафе и рестораны',
    before: 320,
    after: 21000,
    growth: '×17',
    period: '3 месяца',
    note: 'подписчиков с нуля до активного сообщества',
  },
  {
    company: 'Стоматология «Dental+»',
    niche: 'Медицина',
    before: 450,
    after: 12400,
    growth: '×9',
    period: '5 месяцев',
    note: 'целевых подписчиков и стабильный поток заявок',
  },
  {
    company: 'Фитнес-клуб «Atlas»',
    niche: 'Фитнес',
    before: 680,
    after: 15000,
    growth: '×8',
    period: '3 месяца',
    note: 'подписчиков и очередь на пробные тренировки',
  },
  {
    company: 'Интернет-магазин «Volt»',
    niche: 'E-commerce',
    before: 210,
    after: 23000,
    growth: '×10',
    period: '4 месяца',
    note: 'подписчиков и конверсия в заказы ×1,8',
  },
];

export const resultsTimeline = [
  {
    duration: '2–3 дня',
    title: 'Оформление и создание креативов',
    text: 'Готовим сообщество к запуску: оформляем шапку, обложку и контент, разрабатываем рекламные креативы под вашу нишу и аудиторию.',
    metric: 'до 10 связок креативов',
  },
  {
    duration: '1–2 дня',
    title: 'Настройка и модерация рекламы',
    text: 'Настраиваем рекламный кабинет, запускаем кампании и проходим аккредитацию или модерацию — срок зависит от выбранной платформы.',
    metric: 'кампании активны',
  },
  {
    duration: '30 дней',
    title: 'Продвижение',
    text: 'Кампании работают в фоне: набираем подписчиков, тестируем связки, отключаем неэффективные и масштабируем рабочие.',
    metric: 'первые результаты за месяц',
  },
];